import React from 'react';
import FormSelect from '@shared/form/form-select/form-select';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { FieldErrors } from 'react-hook-form';
import { FieldData } from '../../../types/form.types';
import styleUtils from '../../../styles/style.utils';

interface ContactReasonContentProps {
  reasons: FieldData[];
  errors: FieldErrors;
}

const ContactReasonContent: React.FunctionComponent<ContactReasonContentProps> = ({
  reasons,
  errors
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      {reasons.map((reason, index) => {
        const errorMessage =
          errors && reason.name && errors[reason.name]
            ? errors[reason.name].message
            : null;

        return (
          <FormSelect
            key={`form-select-key-${reason.name}`}
            label={reason.label}
            placeholder={
              reason.placeholder
                ? reason.placeholder
                : t('form.selectSomething')
            }
            name={reason.name ? reason.name : reason.label}
            options={reason.options}
            errorMessage={errorMessage}
            isRequired={reason.validation.required}
            showRequiredLegend={index === 0}
          />
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  padding: 0 ${styleUtils.px(16)};
`;

export default ContactReasonContent;
